import {
  BoxProps,
  Center,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Show,
} from "@chakra-ui/react";
import { ReactNode } from "react";

interface ModalDrawerProps {
  isOpen: boolean;
  closeAlert: () => void;
  children: ReactNode;
  header?: ReactNode;
  headerProps?: BoxProps;
  contentProps?: BoxProps;
  bodyProps?: BoxProps;
  closeOnOverlayClick?: boolean;
  maxH?: string;
  onlyMobile?: boolean;
}

const ModalDrawer = ({
  isOpen,
  closeAlert,
  children,
  header,
  headerProps = {},
  contentProps = {},
  bodyProps = {},
  closeOnOverlayClick = true,
  maxH = "75%",
  onlyMobile = false,
}: ModalDrawerProps) => {
  return (
    <>
      {!onlyMobile && (
        <Show above="md">
          <Modal
            isOpen={isOpen}
            onClose={closeAlert}
            isCentered
            closeOnOverlayClick={closeOnOverlayClick}
          >
            <ModalOverlay bg="#075A5A4D" />
            <ModalContent
              w="max-content"
              maxW="max-content"
              bg="backgroundCard"
              borderRadius="1.5rem"
              boxShadow="0px 32px 16px rgba(0, 0, 0, 0.12)"
              {...contentProps}
            >
              {header && <ModalHeader {...headerProps}>{header}</ModalHeader>}
              <ModalBody p="0" {...bodyProps}>
                {children}
              </ModalBody>
            </ModalContent>
          </Modal>
        </Show>
      )}

      <Show below="md">
        <Drawer
          isOpen={isOpen}
          onClose={closeAlert}
          placement="bottom"
          closeOnOverlayClick={closeOnOverlayClick}
        >
          <DrawerOverlay bg="#075A5A4D" />
          <DrawerContent
            bg="backgroundCard"
            borderTopRadius="2rem"
            maxH={maxH}
            {...contentProps}
          >
            {header && <DrawerHeader {...headerProps}>{header}</DrawerHeader>}
            <DrawerBody p="0" {...bodyProps}>
              <Center flexDirection="column" fontWeight="600">
                {children}
              </Center>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Show>
    </>
  );
};

export default ModalDrawer;
